// extracted by mini-css-extract-plugin
module.exports = {"table":"TableDocuments_table__1QGdT","message":"TableDocuments_message__2SXDS","file__delete":"TableDocuments_file__delete__1w6Un"};